/**
 * Prevents mouse wheel events from changing number input values
 * @param event The wheel event
 */
export const disableWheelOnInput = (event: React.WheelEvent) => {
  // Check if the target is an input element
  if (
    event.target instanceof HTMLInputElement &&
    event.target.type === "number"
  ) {
    // Prevent the default behavior (value change)
    event.preventDefault();
    event.target.blur();
  }
};
